import React, { Suspense } from 'react'

import { Route, Switch } from 'react-router-dom'

import { LayoutSplashScreen } from '_metronic'

import {
  PLANTILLASGENERALESCONTABILIDAD_LISTA,
  PLANTILLASGENERALESCONTABILIDAD_NUEVO,
  PLANTILLASGENERALESCONTABILIDAD_EDITAR
} from 'constants/codigosTransacciones'

import ListaPage from './lista'
import NuevoPage from './nuevo'
import EditarPage from './editar'

export default function AsientosContablesPage() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        <Route path={`/${PLANTILLASGENERALESCONTABILIDAD_LISTA}`} component={ListaPage} />
        <Route path={`/${PLANTILLASGENERALESCONTABILIDAD_NUEVO}`} component={NuevoPage} />
        <Route path={`/${PLANTILLASGENERALESCONTABILIDAD_EDITAR}/:id`} component={EditarPage} />
      </Switch>
    </Suspense>
  )
}
